/* global __BUILD_DATE__ */
// The game's version, shown small next to the logo in the header (and at GET /api/version). To ship a new release:
//   1. bump GAME_VERSION here, 2. add an entry to CHANGELOG.md, 3. commit and deploy.
export const GAME_VERSION = 'V1.32'
// The day this build was made (baked in by Vite; 'dev' while running the dev server).
export const BUILD_DATE = typeof __BUILD_DATE__ === 'string' ? __BUILD_DATE__ : 'dev'
